<p-toast position="bottom-center" [preventOpenDuplicates]="true"></p-toast>

<div class="app-container">
  <!-- Fixed Navigation Header -->
  <nav class="app-header bg-white shadow-sm">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <div class="flex items-center">
          <span class="logo-link">
            <img src="assets/images/codaclean.png" [alt]="'global.logo_alt' | transloco" class="logo-img"/>
          </span>
        </div>
        <!-- Language Switcher -->
        <div class="flex items-center bg-gray-100 rounded-lg p-0.5">
          @for (lang of languages; track lang.short) {
            <button
              (click)="switchLanguage(lang)"
              [title]="lang.label"
              [class]="getLanguageButtonClass(lang)"
              class="px-3 py-1.5 text-sm rounded-md transition-all duration-200 focus:outline-none cursor-pointer uppercase">
              {{ lang.short }}
            </button>
          }
        </div>
      </div>
    </div>
  </nav>

  <!-- Scrollable Content Area -->
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer class="app-footer">
    <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-2">
      <span class="text-sm text-gray-500">&copy; {{ currentYear }} Codaclean. All rights reserved.</span>
      <a href="https://www.codaclean.io/" target="_blank" rel="noopener noreferrer" class="text-sm text-primary-600 hover:text-primary-700 transition-colors">
        www.codaclean.io
      </a>
    </div>
  </footer>
</div>
